<ng-template [ngIf]="link">
  <ion-button [href]=link [expand]='expand' [fill]='fill' [size]='size' [color]='color' [target]='target'>{{text}}</ion-button>
</ng-template>